export const BG_COVER = `https://user-images.githubusercontent.com/106049860/180781673-28759fb2-a4e9-4c2c-b15b-95b5d227df01.jpg`;
export const BG_COUNTING_DOWN = `https://user-images.githubusercontent.com/106049860/180806831-8e791a58-8ecd-40cd-8e95-259dd9d5216d.jpg`;
export const BG_INSTAGRAM_FILTER = `https://user-images.githubusercontent.com/106049860/182014880-0272c846-61ce-4b0f-b252-5fcd55df4f5f.jpg`;

// wedding detail image
export const IMG_DRESSCODE = `https://user-images.githubusercontent.com/10141928/169198604-51a5748c-b5ca-4a7b-8576-d9bf6945e0d6.jpg`;

// wedding logo
export const IMG_LOGO_US = `https://user-images.githubusercontent.com/106049860/180783052-80fe6303-46d1-4de0-a4b8-287a4d266a9b.png`;
export const IMG_LOGO_WIF = `https://user-images.githubusercontent.com/106049860/180783046-302cae67-8c32-4e68-abbe-7cfd7b0db61e.png`;
export const IMG_LOGO_ASPEDI = `https://user-images.githubusercontent.com/106049860/180820790-f3b3da98-5e0d-44c3-a7ef-4ee329056cef.png`;

// couple image
export const IMG_LIVE_STREAMING = `https://user-images.githubusercontent.com/106049860/174635873-b4ec4d9b-d73f-4971-9510-d238110b1214.jpg`
export const IMG_COUPLE = `https://user-images.githubusercontent.com/10141928/168089449-ddcfa248-9a78-4c6c-981a-423fbb8be588.jpg`;
export const IMG_LOVE_STORY = `https://user-images.githubusercontent.com/10141928/159170187-5510f1d8-b8ad-4443-98ac-5b748f696254.jpg`;
export const IMG_GIRL = `https://user-images.githubusercontent.com/106049860/174349043-241d90ab-5754-411a-a6f1-ec231247a76b.jpg`;
export const IMG_MAN = `https://user-images.githubusercontent.com/106049860/174349058-468ab452-8823-4d8a-a698-9a9d214b7c92.jpg`;
export const IMG_PHOTO_GALLERY = `https://user-images.githubusercontent.com/10141928/159386150-dc272b52-0274-4bdb-b839-3fa155a69917.jpg`;
export const IMG_WELCOMING_SECTION = `https://user-images.githubusercontent.com/106049860/180789971-a0c938c3-3509-4664-b93a-d3058b3bd7c3.png`;

// gallery
export const IMG_GALLERY_COVER = `https://user-images.githubusercontent.com/106049860/174437098-07905c03-d3bb-4173-b4d8-a65ab4406288.jpg`
export const IMG_GALLERY_FIRST = IMG_GALLERY_COVER;

/**
 * Image Assets
 * @important - IF YOU WANT TO OVERRIDE THIS ASSETS,
 * MAKE SURE YOU REPLACE WITH SAME RESOLUTION
 */
export const ASSETS_PHOTO_LEFT = `https://user-images.githubusercontent.com/106049860/174345569-8f80c1a3-e2b3-472f-a53f-9e166f854f1d.png`;
export const ASSETS_PHOTO_LEFT_INVERT = `https://user-images.githubusercontent.com/106049860/174415823-763cea06-4da6-4023-ac14-0831fb6b8a96.png`;

/**
 * Invitato Image Assets
 * @important - DON'T CHANGE THIS CODE
 */
export const LOGO_INVITATO = `https://user-images.githubusercontent.com/10141928/150662036-816aabf8-76f9-4342-bc47-3d7892362753.png`;
export const IMG_COVID = {
  id: `https://user-images.githubusercontent.com/10141928/152914092-4dfb40e5-9552-49dc-a2d4-72a345f08b06.png`,
  en: `https://user-images.githubusercontent.com/10141928/158618733-55b6141e-dc5a-4a6e-a65e-953cb09127dc.jpg`,
};
